module.exports = __webpack_public_path__ + "static/media/download.da01079f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/download.svg
// module id = 950
// module chunks = 0